<div class="auth-screen">
  <div class="auth-layout app-stack">

    <section class="app-page-card app-stack">
      <div class="auth-brand">
        <div class="auth-icon-wrap" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="auth-icon-svg">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" fill="currentColor" opacity=".9"/>
            <polyline points="9 22 9 12 15 12 15 22" fill="#fff" opacity=".6"/>
          </svg>
        </div>
        <div>
          <p class="app-eyebrow">Propraize</p>
          <h1>Redirecting to Microsoft sign-in…</h1>
        </div>
      </div>

      <calcite-loader label="Redirecting to Microsoft sign-in" text="One moment…"></calcite-loader>
    </section>

  </div>
</div>
